import { useState } from 'react';

import {
  formatTrustLevelName,
  ITrader,
  useChangeTraderTrustLevelMutation,
  useTrustLevelsOptions,
} from '@entities/trades/trader';
import { Select } from '@shared/components/Form';

import './ChangeTraderTrustLevel.css';

interface IProps {
  trader: ITrader;
  refetch: () => void;
}

export const ChangeTraderTrustLevel = ({ trader, refetch }: IProps) => {
  const { options, isLoading: isOptionsLoading } = useTrustLevelsOptions();
  const [changeTrustLevel, { isLoading }] = useChangeTraderTrustLevelMutation();
  const [revertKey, setRevertKey] = useState(0);

  const currentId = trader.trust_level?.id;

  const handleChange = async (value: string) => {
    if (!value) return;
    const next = Number(value);
    if (!Number.isFinite(next) || next === currentId) return;

    const result = await changeTrustLevel({ id: trader.id, trust_level_id: next });
    if ('data' in result) {
      refetch();
    } else {
      setRevertKey(k => k + 1);
    }
  };

  return (
    <div className='trust-level-cell'>
      <span>{formatTrustLevelName(trader.trust_level)}</span>
      <Select
        key={`${currentId ?? 'none'}-${revertKey}`}
        name={`trust-level-${trader.id}`}
        options={options}
        getOptionLabel={o => o.label}
        getOptionValue={o => o.id}
        selectedValue={currentId ? String(currentId) : ''}
        onChange={handleChange}
        isDisabled={isLoading || isOptionsLoading}
      />
    </div>
  );
};
